import React, { useState, useEffect, useRef } from 'react';
import { Tab, Tabs, Accordion, Button, Offcanvas } from 'react-bootstrap';
import { Link, NavLink } from "react-router-dom";
import edafacelogo from "../Assets/edaface-logo1.png";
import { IoClose } from "react-icons/io5";
import GTranslateWidget from "./gtranslate";
import { IoIosArrowDown } from "react-icons/io";


const Codedetail = (props) => {

    const [headermobile, setHeadermobile] = useState(true);

    const [opened, setOpened] = useState(false);
    const data = [
        {
            id: 0,
            title: 'Cryptocurrencies',
            link: "https://edaface.com/cryptocurrencies",
            content: [
                {
                    subId: 0,
                    subTitle: 'Coin Ranking',
                    link: "https://edaface.com/coin-ranking",
                },
                {
                    subId: 1,
                    subTitle: 'Trending',
                    link: "https://edaface.com/trending",
                },
                {
                    subId: 2,
                    subTitle: 'Eda Coin',
                    link: "https://edaface.com/eda-coin",
                },
                // {
                //     subId: 3,
                //     subTitle: 'P2P Trading',
                //     link: "https://p2pmarket.edaface.com/",
                // },
            ],
        },
        {
            id: 1,
            title: 'Exchanges',
            link: "https://edaface.com/exchanges",
            content: [
                {
                    subId: 0,
                    subTitle: 'Cex Listing',
                    link: "https://edaface.com/cex-listing",
                    subContent: [
                        {
                            subId: 0,
                            subTitle: 'Cex Spot',
                            link:"https://edaface.com/cex-spot",
                        },
                        {
                            subId: 1,
                            subTitle: 'Cex Derivatives',
                            link:"https://edaface.com/cex-derivatives",
                        },
                    ],
                },
                {
                    subId: 1,
                    subTitle: 'Dex Listing',
                    link: "https://edaface.com/dex-listing",
                    subContent: [
                        {
                            subId: 0,
                            subTitle: 'Cex Spot',
                            link:"https://edaface.com/cex-spot",
                        },
                        {
                            subId: 1,
                            subTitle: 'Cex Derivatives',
                            link:"https://edaface.com/cex-derivatives",
                        },
                    ],
                },
                {
                    subId: 2,
                    subTitle: 'EdaFace Dex',
                    link: "https://edaface.com/dex",
                },
                // {
                //     subId: 3,
                //     subTitle: 'Eda Plantation',
                //     link: "https://home.edaface.com/eda-plantation",
                // },
            ],
        },
        {
            id: 2,
            title: 'Verification Centre',
            link: "https://edaface.com/verification-centre",
            content: [
                {
                    subId: 0,
                    subTitle: 'Scam Verification',
                    link: "https://edaface.com/rug-pull-check",
                },
                {
                    subId: 1,
                    subTitle: 'List Your Projects',
                    link: "https://edaface.com/list-your-projects",
                },
                {
                    subId: 2,
                    subTitle: 'EdaFace Launchpad',
                    link: "https://edaface.com/edaface-launchpad",
                },
            ],
        },
        {
            id: 3,
            title: 'Market Places',
            link: "https://edaface.com/market-places",
            content: [
                {
                    subId: 0,
                    subTitle: 'NFT Marketplace',
                    link: "https://edaface.com/nft-market-place",
                },
                {
                    subId: 1,
                    subTitle: 'Blockchain Litrature',
                    link: "https://edaface.com/blockchain-literature",
                },
                {
                    subId: 2,
                    subTitle: 'EdaFace Mall',
                    link: "https://edaface.com/edaface-mall",
                },
                {
                    subId: 3,
                    subTitle: 'P2P Market',
                    link: "https://edaface.com/p2pmarket",
                },
                {
                    subId: 4,
                    subTitle: 'Metaverse',
                    link: "https://edaface.com/metaverse",
                },
            ],
        },
        {
            id: 4,
            title: 'EdaFace Academy',
            link: "https://edaface.com/academy",
            content: [
                {
                    subId: 0,
                    subTitle: 'School of Cryptocurrencies',
                    link: "https://edaface.com/school-of-cryptocurrencies",
                },
                {
                    subId: 1,
                    subTitle: 'EdaFace Newsfeed',
                    link: "https://edaface.com/newsfeed",
                },
                {
                    subId: 2,
                    subTitle: 'Digital Clinic',
                    link: "https://edaface.com/digital-clinic",
                },
                {
                    subId: 3,
                    subTitle: 'EdaFace Tutor',
                    link: "https://edaface.com/tutor",
                },
            ],
        },
        {
            id: 5,
            title: 'Resources',
            link:"https://edaface.com/resources",
            content: [
                {
                    subId: 0,
                    subTitle: 'About Us',
                    link:"https://edaface.com/about-edaface",
                    subContent: [
                        {
                            subId: 0,
                            subTitle: 'Vision',
                            link:"https://edaface.com/vision",
                        },
                        {
                            subId: 1,
                            subTitle: 'Mission',
                            link:"https://edaface.com/mission",
                        },
                        {
                            subId: 2,
                            subTitle: 'Core Values',
                            link:"https://edaface.com/core-values",
                        },
                        {
                            subId: 3,
                            subTitle: 'Branding',
                            link:"https://edaface.com/branding",
                        },
                    ],
                },
                {
                    subId: 1,
                    subTitle: 'How To Use EdaFace',
                    link:"https://info.edaface.com/",
                },
                {
                    subId: 2,
                    subTitle: 'EdaFace Team',
                    link:"https://info.edaface.com/knowledge-base/article/edaface-team",
                    subContent: [
                        {
                            subId: 0,
                            subTitle: 'EdaFace Departments',
                            link:"https://info.edaface.com/knowledge-base/article/departments",
                        },
                        {
                            subId: 1,
                            subTitle: 'Board of Managers',
                            link:"https://info.edaface.com/knowledge-base/article/board-of-managers",
                        },
                        {
                            subId: 2,
                            subTitle: 'Board of Advisiors',
                            link:"https://info.edaface.com/knowledge-base/article/board-of-advisors",
                        },
                        {
                            subId: 3,
                            subTitle: 'EdaFace Partners',
                            link:"https://info.edaface.com/knowledge-base/article/partners",
                        },
                    ],
                },
                // {
                //     subId: 3,
                //     subTitle: 'Whitepaper',
                //     link:"https://home.edaface.com/whitepaper",
                //     subContent: [
                //         {
                //             subId: 0,
                //             subTitle: 'Tokenamics',
                //             link:"https://home.edaface.com/tokenamics",
                //         },
                //         {
                //             subId: 1,
                //             subTitle: 'Utility Cases',
                //             link:"https://home.edaface.com/utility-cases",
                //         },
                //         {
                //             subId: 2,
                //             subTitle: 'Token Characteristicss',
                //             link:"https://home.edaface.com/token-characteristics",
                //         },
                //         {
                //             subId: 3,
                //             subTitle: 'Stakability',
                //             link:"https://home.edaface.com/stakability",
                //         },
                //         {
                //             subId: 3,
                //             subTitle: 'ICO Details',
                //             link:"https://home.edaface.com/ico-details",
                //         },
                //         {
                //             subId: 3,
                //             subTitle: 'Airdrops/Bonuses',
                //             link:"https://home.edaface.com/airdrops-bonuses",
                //         },
                //         {
                //             subId: 3,
                //             subTitle: 'Road Map',
                //             link:"https://home.edaface.com/road-map",
                //         },
                //         {
                //             subId: 3,
                //             subTitle: 'Disclaimer',
                //             link:"https://home.edaface.com/disclaimer",
                //         },
                //     ],
                // },
                // {
                //     subId: 4,
                //     subTitle: 'Team',
                //     link:"https://home.edaface.com/teams-1",
                //     subContent: [
                //         {
                //             subId: 0,
                //             subTitle: 'Departments',
                //             link:"https://home.edaface.com/Departments",
                //         },
                //         {
                //             subId: 1,
                //             subTitle: 'Board of Founders',
                //             link:"https://home.edaface.com/board-of-founders",
                //         },
                //         {
                //             subId: 2,
                //             subTitle: 'Board of Advisors',
                //             link:"https://home.edaface.com/board-of-advisors",
                //         },
                //         {
                //             subId: 3,
                //             subTitle: 'Partners',
                //             link:"https://home.edaface.com/partners",
                //         },
                //     ],
                // },
                {
                    subId: 5,
                    subTitle: 'FAQ',
                    link:"https://edaface.com/faq",
                    subContent: [
                        {
                            subId: 0,
                            subTitle: 'FAQ About Team',
                            link:"https://edaface.com/faq-about-team",
                        },
                        {
                            subId: 1,
                            subTitle: 'FAQ About EdaFace',
                            link:"https://edaface.com/faq-about-edaface",
                        },
                        {
                            subId: 2,
                            subTitle: 'FAQ About Eda Coin',
                            link:"https://edaface.com/faq-about-eda-coin",
                        },
                    ],
                },
            ],
        },
    ];



    return (

        <>

            <div className='viewcanvas'>
                <Offcanvas show={headermobile} placement='end' name="end">
                    <Offcanvas.Header>
                        <Link className="d-flex" to="/"><img src={edafacelogo} className="logos" alt="logos" /></Link>
                        <button className='btn close' onClick={() => props.onDismiss()}><IoClose /></button>
                    </Offcanvas.Header>
                    <Offcanvas.Body>
                        {/* <div className='text-center mb-3'><GTranslateWidget /></div> */}
                       <div className='mob-accordion'>
                        <Accordion>
                            {data.map((item) => (
                                <Accordion.Item eventKey={item.id.toString()} key={item.id}>
                                    <Accordion.Header><Link to={item.link}>{item.title}</Link></Accordion.Header>
                                    <Accordion.Body className='py-1 ps-4'>
                                        <Accordion>
                                            {item.content.map((subItem) => (
                                                <Accordion.Item className='subaccitem' eventKey={subItem.subId.toString()} key={subItem.subId}>
                                                    {
                                                        subItem.subContent ?
                                                            <Accordion.Header><Link to={subItem.link} className='MobileAccordionTitle'>{subItem.subTitle}</Link></Accordion.Header> :
                                                            <Link className='suba ps-2' to={subItem.link}>{subItem.subTitle}</Link>
                                                    }
                                                    {/* <Accordion.Body>{subItem.subContent}</Accordion.Body> */}

                                                    {
                                                        !Array.isArray(subItem.subContent) ?
                                                            <Accordion.Body>{subItem.subContent}</Accordion.Body> :
                                                            <>
                                                                {
                                                                    subItem.subContent?.map(item => (
                                                                        <Accordion.Body className='py-1'>
                                                                            <Accordion>
                                                                                <Accordion.Item eventKey={item.subId.toString()} key={item.subId}>
                                                                                {console.log(item.subContent,"item.subContent")}
                                                                                    {

                                                                                        item.subContent ?
                                                                                            <Accordion.Header><Link to={item.link}>{item.subContent}</Link></Accordion.Header> :
                                                                                            <Link className='suba' to={item.link}>
                                                                                                {item.subTitle}
                                                                                                </Link>
                                                                                    }


                                                                                    {/* <Accordion.Header>{item.subTitle}</Accordion.Header> */}



                                                                                    {/* {
                                                        !Array.isArray(item.subContent) ?
                                                            <Accordion.Body>{item.subContent}</Accordion.Body> :
                                                            <>
                                                                {
                                                                    item.subContent?.map(item1 => (
                                                                        <Accordion.Body>
                                                                            <Accordion>
                                                                                <Accordion.Item eventKey={item1.subId.toString()} key={item1.subId}>
                                                                                    <Accordion.Header>{item1.subTitle}</Accordion.Header>
                                                                                    <Accordion.Body>
                                                                                        {item1.subContent}
                                                                                    </Accordion.Body>
                                                                                </Accordion.Item>
                                                                            </Accordion>
                                                                        </Accordion.Body>
                                                                    ))
                                                                }
                                                            </>
                                                    } */}



                                                                                    {/* <Accordion.Body>
                                                                                        {item.subContent}
                                                                                    </Accordion.Body> */}
                                                                                </Accordion.Item>
                                                                            </Accordion>
                                                                        </Accordion.Body>
                                                                    ))
                                                                }
                                                            </>
                                                    }





                                                </Accordion.Item>
                                            ))}
                                        </Accordion>
                                    </Accordion.Body>
                                </Accordion.Item>
                            ))}
                        </Accordion>
                        </div>

                        {/* <div className='mt-4'>
                                <h4 className='fw-700'>MENU</h4>
                                <h4>Coming Soon..</h4>
                            </div> */}












                    </Offcanvas.Body>
                </Offcanvas>
            </div>


        </>
    )
}

export default Codedetail;
